import { useLocalStore } from "@/context/StateContext"
import { createStore, produce } from "solid-js/store"
import { v4 as uuidv4 } from "uuid"

export interface ItemMetadata {
  name?: string
  [key: string]: any
}

export interface Item extends ItemMetadata {
  id: string
  createdAt: number
  createdBy: string
  updatedAt?: number
  updatedBy?: string
}

export interface ItemsStore {
  items: Record<string, Item>
  addItem: (id?: string, metadata?: ItemMetadata) => void
  updateMetadata: (userId: string, key: string, value: any) => void
  removeItem: (id: string) => void
}

export const [itemsStore, setItemsStore] = createStore({
  items: {},
  addItem: (id = uuidv4(), metadata) => {
    const usersStore = useLocalStore()
    if (!usersStore.activeUserId) {
      throw new Error("No active user")
    }
    setItemsStore("items", produce((items) => {
      items[id] = {
        id,
        createdAt: Date.now(),
        createdBy: usersStore.activeUserId!,
        ...metadata,
      }
    }))
  },
  updateMetadata: (userId, key, value) => {
    const usersStore = useLocalStore()
    if (!usersStore.activeUserId) {
      throw new Error("No active user")
    }
    setItemsStore("items", produce((items) => {
      items[userId][key] = value
      items[userId].updatedAt = Date.now()
      items[userId].updatedBy = usersStore.activeUserId!
    }))
  },
  removeItem: (id) => {
    setItemsStore("items", produce((items) => {
      delete items[id]
    }))
  },
} as ItemsStore)

export default itemsStore
